const protobuf = require('protobufjs');
const proto = require('./../proto/e3play.proto');
const Promise = require('promise');

class ProtobufCommonService {
    _object = null;
    _root = null;

    constructor(type) {
        this._root = protobuf.parse(proto).root;
        this._object = this._root.lookupType(type);
    }

    parseDat(url, callback) {
        return new Promise((res, rej) => {
            const xhr = new XMLHttpRequest();

            xhr.onload = () => {
                if (xhr.status === 200) {
                    res(this.convertToJSON(new Uint8Array(xhr.response)));
                } else {
                    rej(xhr.statusText);
                }
            };
            xhr.onerror = () => rej(xhr.statusText);
            xhr.open('GET', url, true);
            xhr.responseType = "arraybuffer";
            xhr.addEventListener('progress', (e) => {
                callback && callback(e);
            });
            xhr.send(null);
        })
    }

    convertToJSON(encoded) {
        return this._object.decode(encoded)
    }

    getBinary(json) {
        return this._object.encode(this._object.create(json)).finish()
    }
}

export default ProtobufCommonService;